import { Button, Classes, Dialog } from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IEmpresaNotaManual } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { NotasStore } from "../../stores/notas/NotasStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { toast } from "react-toastify";

interface LogsPageState {
  date1: string;
  date2: string;
  date: any;
}

@observer
export default class NotasManual extends React.Component<any, LogsPageState> {
  constructor(props: {}) {
    super(props);

    NotasStore.obs.openModal = true;
  }

  componentDidMount() {
  }

  handleCloseModal() {
    NotasStore.obs.openModal = false;
  }

  async handleDelNotasManual() {
    await NotasStore.deleteNotasManual();

    if (NotasStore.obs.result_ok) {
      toast.success('Gravações efetuadas', {});
      await NotasStore.loadAtrasadasManual();
      ResultadoStore.obs.notasManual = false;
    } else {
      toast.error('Erro ao efetuar Gravações', {});
    }
  }

  render() {
    return (
      <>
        <Dialog
          isOpen={NotasStore.obs.openModal}
          title="Atenção"
          onClose={() => this.handleCloseModal()}
          style={{ width: 700 }}
          className="modal-manual-emp"
        >
          <div className={Classes.DIALOG_BODY}>
            <MDBRow>
              <MDBCol md="12">
                <h3 className="titleProccess">
                  Esta(s) empresa(s) estão com nota(s) cujo o mês do cálculo
                  esta diferente do mês da emissão, como são empresas
                  COMPETÊNCIA isso impacta no fechamento do mês
                </h3>
                <h3 className="titleProccess">
                  <u>
                    Você tem a opção de manter assim ou contestar os itens para
                    a mesma data da emissão da nota, se desejar mater as datas
                    diferentes basta clicar no botão SIM
                  </u>
                </h3>
              </MDBCol>
            </MDBRow>

            <div className="AlertImportacoes grid-emp-erro">
              {NotasStore.obs.empresasAtrasadasManual?.map((el: IEmpresaNotaManual) => (
                <div key={el.cnpj_destino} className="bloco-emp-atrasadas noPointer">
                  <div className="emp-erro_info">
                    <div className="emp-erro_nome" title={el.razao_social}>
                      {el.razao_social}
                    </div>
                    <div className="emp-erro_cnpj">{el.cnpj_destino}</div>
                  </div>
                  <span className="badge-emp pulse badge-emp-calculo" />
                </div>
              ))}
            </div>

            <div style={{ display: "flex", width: "100%", marginBottom: -80, justifyContent: "end", gap: 10 }}>
              <Button
                onClick={() => this.handleDelNotasManual()}
                className="certiDigitalTeste"
              >
                SIM, manter o mês de cálculo diferente da emissão para TODAS AS EMPRESAS
              </Button>
              <Button
                onClick={() => this.handleCloseModal()}
                className="closeRetroativas"
              >
                Fechar
              </Button>
            </div>
          </div>
        </Dialog>
      </>
    );
  }
}
